module.exports = __webpack_public_path__ + "8f0a77408e5a203e01ef3f1024ab1485.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/banner-image.png
// module id = 1902
// module chunks = 0